/**
 * @generated SignedSource<<f6d061d5e779ced455f3068ec393e427>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfileScreenEmployeeSetProfileImageMutation$variables = {
  employeeId: string;
  imageId: string;
};
export type ProfileScreenEmployeeSetProfileImageMutation$data = {
  readonly employee: {
    readonly setProfileImage: {
      readonly id: string;
      readonly image: {
        readonly __typename: "Image";
        readonly id: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    };
  } | null;
};
export type ProfileScreenEmployeeSetProfileImageMutation$rawResponse = {
  readonly employee: {
    readonly setProfileImage: {
      readonly id: string;
      readonly image: {
        readonly __typename: "Image";
        readonly id: string;
      } | {
        readonly __typename: string;
      } | null;
    };
  } | null;
};
export type ProfileScreenEmployeeSetProfileImageMutation = {
  rawResponse: ProfileScreenEmployeeSetProfileImageMutation$rawResponse;
  response: ProfileScreenEmployeeSetProfileImageMutation$data;
  variables: ProfileScreenEmployeeSetProfileImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "employeeId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "imageId",
    "variableName": "imageId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileScreenEmployeeSetProfileImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "EmployeeMutation",
        "kind": "LinkedField",
        "name": "employee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "setProfileImage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "type": "Image",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProfileScreenEmployeeSetProfileImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "EmployeeMutation",
        "kind": "LinkedField",
        "name": "employee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "setProfileImage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "Image",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6588a3b7e198cade86fdd7cbba308a0f",
    "id": null,
    "metadata": {},
    "name": "ProfileScreenEmployeeSetProfileImageMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileScreenEmployeeSetProfileImageMutation(\n  $imageId: ID!\n  $employeeId: ID!\n) {\n  employee(id: $employeeId) {\n    setProfileImage(imageId: $imageId) {\n      id\n      image {\n        __typename\n        ... on Image {\n          id\n          __typename\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffeba22740f20901c53900f565c9f2d3";

export default node;
